import React, { useEffect, useState } from "react";
import qs from "qs";
import moment from "moment";
import Table from "../../common/table";
import { useGetRewardCredits } from "../../../queryHooks/useRewards";

// A redemption converts points into OPA credit at a ladder tier. Credit is valid 30 days.
const STATUS_OPTIONS = [
	{ label: "Available", value: "AVAILABLE", color: "success" },
	{ label: "Used", value: "USED", color: "info" },
	{ label: "Expired", value: "EXPIRED", color: "secondary" },
	{ label: "Reversed", value: "REVERSED", color: "danger" },
];
const statusMeta = (value) => STATUS_OPTIONS.find((s) => s.value === value) || { label: value, color: "secondary" };

const userLabel = (credit) =>
	[credit.user?.firstName, credit.user?.lastName].filter(Boolean).join(" ") || credit.user?.email || credit.userId;

const Redemptions = () => {
	const [statusFilter, setStatusFilter] = useState("");
	const [pageNow, setPageNow] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [tableData, setTableData] = useState({ records: [], total_items: 0, page: 1, items_per_page: 10 });

	const payload = {
		page: pageNow,
		limit: itemsPerPage,
		...(statusFilter ? { status: statusFilter } : {}),
	};
	const { data, isLoading } = useGetRewardCredits(qs.stringify(payload));
	useEffect(() => {
		if (data?.status === "success") setTableData(data.data);
	}, [data]);

	const columns = [
		{
			label: "Redeemed",
			type: "string",
			path: "createdAt",
			content: (item) => moment(item.createdAt).format("YYYY-MM-DD HH:mm"),
		},
		{
			label: "User",
			type: "string",
			path: "userId",
			content: (item) => <span title={item.userId}>{userLabel(item)}</span>,
		},
		{
			label: "Points",
			type: "number",
			path: "points",
			content: (item) => item.points.toLocaleString(),
		},
		{
			label: "Credit",
			type: "number",
			path: "creditAmount",
			content: (item) => <strong>${item.creditAmount.toFixed(2)}</strong>,
		},
		{
			label: "Status",
			type: "string",
			path: "status",
			content: (item) => <span className={`status-badge ${statusMeta(item.status).color}`}>{statusMeta(item.status).label}</span>,
		},
		{
			label: "Expires",
			type: "string",
			path: "expiresAt",
			content: (item) => moment(item.expiresAt).format("YYYY-MM-DD"),
		},
		{
			label: "Order",
			type: "string",
			path: "orderId",
			content: (item) => item.orderId || "-",
		},
	];

	return (
		<div className="module-section">
			<div className="section-header">
				<h3>Redemptions</h3>
				<div className="header-stats">
					<div className="stat-card">
						<div className="stat-label">Redemptions</div>
						<div className="stat-value">{(tableData.total_items || 0).toLocaleString()}</div>
					</div>
				</div>
			</div>

			<div className="section-filters">
				<select
					className="form-control"
					value={statusFilter}
					onChange={(e) => {
						setPageNow(1);
						setStatusFilter(e.target.value);
					}}
					style={{ maxWidth: "200px" }}
				>
					<option value="">All Statuses</option>
					{STATUS_OPTIONS.map((s) => (
						<option key={s.value} value={s.value}>
							{s.label}
						</option>
					))}
				</select>
				<span className="text-muted small" style={{ alignSelf: "center" }}>
					To cancel a redemption and return the points, reverse its entry in the Ledger tab.
				</span>
			</div>

			<Table
				columns={columns}
				columnKey="rewards_redemptions"
				tableData={tableData}
				loading={isLoading}
				setCurrentPage={(page) => setPageNow(page)}
				setCurrentLimit={(limit) => {
					setPageNow(1);
					setItemsPerPage(limit);
				}}
			/>
		</div>
	);
};

export default Redemptions;
